import type { SummaryMonthState, SummaryPerson, SummaryPersonKind, SummarySpan } from './types.js'

/** Wording shared by the summary's screens. */

export const FEATURE_KEY = 'performance_reviews'
export const FEATURE_NAME = 'Performance Summaries'

export const MONTH_STATE_LABELS: Record<SummaryMonthState, string> = {
  final: 'Closed',
  no_score: 'No score',
  before_hire: 'Before hire',
  in_progress: 'In progress, not counted',
}

export const TIER_REASON_LABELS: Record<string, string> = {
  score: 'From the score',
  new_hire: 'New hire: probationary',
  provisional_held: 'Provisional: tier held',
  no_score: 'Nothing scored: tier held',
  no_thresholds: 'No thresholds: tier held',
}

const PERSON_KIND_LABELS: Record<SummaryPersonKind, string> = {
  operator: 'operator',
  facility_administrator: 'facility administrator',
  platform_admin: 'SeeWhoCares admin',
  partner: 'HR integration',
}

export function personLabel(person: SummaryPerson): string {
  return `${person.name ?? PERSON_KIND_LABELS[person.kind]}${person.name ? ` (${PERSON_KIND_LABELS[person.kind]})` : ''}`
}

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** `2026-03` as `Mar 2026`. */
export function monthLabel(period: string): string {
  const month = Number(period.slice(5, 7))
  return `${MONTH_NAMES[month - 1] ?? period.slice(5, 7)} ${period.slice(0, 4)}`
}

export function spanLabel(span: SummarySpan): string {
  return span.from === span.to ? monthLabel(span.from) : `${monthLabel(span.from)} to ${monthLabel(span.to)}`
}

export function formatWhen(iso: string): string {
  const date = new Date(iso)
  return Number.isNaN(date.getTime()) ? iso : date.toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}

export function percent(numerator: number, denominator: number): string {
  return denominator === 0 ? '—' : `${Math.round((numerator / denominator) * 1000) / 10}%`
}
